"use client";

import { useState } from "react";
import { CommonConfigWriteModal } from "./Modal";
import {
  Panel,
  PanelBody,
  PanelHeader,
  AdminTitle,
  AdminBreadcrumb,
} from "@/shared";
import { AdminArticlePath, AdminArticleTitle } from "@/entities";

export function AdminCommonConfigInit() {
  const [isOpen, setIsOpen] = useState(false);
  const onShow = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);

  return (
    <>
      <div className="d-flex align-items-center">
        <div>
          <AdminBreadcrumb items={AdminArticlePath} />
          <AdminTitle title={AdminArticleTitle} />
        </div>
        <div className="ms-auto"></div>
      </div>
      <Panel>
        <PanelHeader>안내</PanelHeader>
        <PanelBody className="p-0">
          <p className="m-5 text-center">
            모듈을 생성해주세요.
            <br />
            <button className="btn btn-inverse" onClick={onShow}>
              <i className="fa fa-plus"></i>
              <span>모듈 생성</span>
            </button>
            <CommonConfigWriteModal isOpen={isOpen} onClose={onClose} />
          </p>
        </PanelBody>
      </Panel>
    </>
  );
}
